export const SALES_ORDER = 'SalesOrder';
export const SalesOrderStatusValues = [
    'draft',
    'confirmed',
    'partially-shipped',
    'shipped',
    'cancelled',
];
export const SALES_ORDER_STATUS_LABELS = {
    draft: 'Rascunho',
    confirmed: 'Confirmado',
    'partially-shipped': 'Parcialmente expedido',
    shipped: 'Expedido',
    cancelled: 'Cancelado',
};
//# sourceMappingURL=sales-order.js.map